// extracted by mini-css-extract-plugin
export default {"container":"U9-z","productName":"V9-z","price":"W9-z","dimensions":"X9-z"};